// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zDsTUb7m3YwLpmhwHyL7{
    position: fixed;
    top: 10px;
    right: 10px;
    padding: 10px 20px;
    background-color: var(--accent-color);
    color: var(--accent-text-color);
    border-radius: 5px;
    border: double 2px var(--border-color);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }
  `, "",{"version":3,"sources":["webpack://./src/NotificationComponent.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,+BAA+B;IAC/B,kBAAkB;IAClB,sCAAsC;IACtC,wCAAwC;IACxC,aAAa;EACf","sourcesContent":[".NotificationComponent{\n    position: fixed;\n    top: 10px;\n    right: 10px;\n    padding: 10px 20px;\n    background-color: var(--accent-color);\n    color: var(--accent-text-color);\n    border-radius: 5px;\n    border: double 2px var(--border-color);\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n    z-index: 1000;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NotificationComponent": `zDsTUb7m3YwLpmhwHyL7`
};
export default ___CSS_LOADER_EXPORT___;
